import React from 'react';
import ReportViewer from "./base/ReportViewer";

const StatistiquesFichiersEnregistrement = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"StatistiquesFichiersEnregistrement"}/>
        </div>
    );
}
export default StatistiquesFichiersEnregistrement;